import { Button } from "@synthesis/shared-ui";

import IconLogout from "@synthesis/shared-icons/IconLogout";
import { useAuth } from "react-oidc-context";

export const ProfileLogoutButton = () => {
  const auth = useAuth();

  return (
    <Button
      type="button"
      theme="secondary"
      size="sm"
      className="mt-6"
      leftIcon={<IconLogout className="size-5" />}
      onClick={() => auth.signoutRedirect()}
    >
      Выйти
    </Button>
  );
};
